import { Button, Loading, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface ClientsConfirmStepProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  confirmLabel: string;
  cancelLabel?: string;
  /** Renders the confirm button in the destructive (red) style. */
  danger?: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Shared confirm-dialog body for the client row actions (remove access, reactivate, resend / cancel invite). */
export const ClientsConfirmStep = ({
  title,
  confirmLabel,
  cancelLabel = "Cancel",
  danger = false,
  isLoading = false,
  onConfirm,
  onClose,
  className,
  children,
  ...props
}: ClientsConfirmStepProps) => (
  <div className={clsx("relative", className)} {...props}>
    {isLoading && <Loading />}
    <div className="max-w-lg sm:flex sm:items-start">
      <div className="mt-3 text-center sm:mt-0 sm:text-left">
        <Typography variant="title">{title}</Typography>
        <div className="mt-3 space-y-3 text-neutral-dark-gray">{children}</div>
      </div>
    </div>
    <div className="mt-6 flex justify-end gap-4">
      <Button variant="secondary" onClick={onClose} className="px-8">
        {cancelLabel}
      </Button>
      <Button variant="primary" onClick={onConfirm} className={clsx("px-8", danger && "!bg-danger hover:!bg-danger-dark")}>
        {confirmLabel}
      </Button>
    </div>
  </div>
);
